import React, { memo } from 'react';
import { HeaderWrapper, HeaderRow } from '@dealroadshow/uikit/core/components/Table/DataTable';
import { COLUMNS } from './HeaderColumns';

const TableHeader = () => (
  <HeaderWrapper>
    <HeaderRow columns={ COLUMNS } />
  </HeaderWrapper>
);

export default memo(TableHeader);
